import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import fr from "../locales/fr/translation.json";
import en from "../locales/en/translation.json";

const supportedLanguages = ["fr", "en"];

const getInitialLanguage = () => {
    if (typeof window === "undefined") {
        return "fr";
    }

    const savedLanguage = window.localStorage.getItem("language");

    if (savedLanguage && supportedLanguages.includes(savedLanguage)) {
        return savedLanguage;
    }

    return "fr";
};

const initialLanguage = getInitialLanguage();

i18n.use(initReactI18next).init({
    resources: {
        fr: {
            translation: fr,
        },
        en: {
            translation: en,
        },
    },
    lng: initialLanguage,
    fallbackLng: "fr",
    interpolation: {
        escapeValue: false,
    },
});

if (typeof document !== "undefined") {
    document.documentElement.lang = initialLanguage;
}

i18n.on("languageChanged", (language) => {
    if (typeof window !== "undefined") {
        window.localStorage.setItem("language", language);
    }

    if (typeof document !== "undefined") {
        document.documentElement.lang = language;
    }
});

export default i18n;
